import { GetterTree } from 'vuex';

import store from './filter-wrapper-types.store';
import { IFilterWrapperState } from "./filter-wrapper-states.store";

export const getters: GetterTree<IFilterWrapperState, any> = {
    [store.Get.PROPERTY_SEARCH_PARAM]: (state: IFilterWrapperState) => state.propertySearchParam,
    [store.Get.PERSON_SEARCH_PARAM]: (state: IFilterWrapperState) => state.personSearchParam,
    [store.Get.DEMAND_SEARCH_PARAM]: (state: IFilterWrapperState) => state.demandSearchParam,
    [store.Get.TASK_SEARCH_PARAM]: (state: IFilterWrapperState) => state.taskSearchParam,
}